const SWIPE_THRESHOLD = 50;

export function createGridSwipeHandlers(component) {
    let touchStartX = 0;
    let touchStartY = 0;
    let tracking = false;

    const onTouchStart = (event) => {
        if (!event.touches || event.touches.length !== 1) {
            return;
        }

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        tracking = true;
    };

    const onTouchEnd = (event) => {
        if (!tracking || !event.changedTouches || event.changedTouches.length !== 1) {
            tracking = false;
            return;
        }

        tracking = false;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) {
            return;
        }

        if (deltaX < 0) {
            component.nextSlide();
        } else {
            component.prevSlide();
        }
    };

    return { onTouchStart, onTouchEnd };
}
